import { ReactElement, useCallback } from "react";
import { useHubImageViewerDialog } from "./HubImageViewerDialog";
import { isNil } from "client/Misc/utils";
import { ImageUrlWithAttribution } from "./common";

export function useImageViewer(
	images?: readonly ImageUrlWithAttribution[]
): [
	dialogElement: ReactElement | null,
	onViewImage: (image: ImageUrlWithAttribution) => void
] {
	const [imageViewerDialog, openImageViewerDialog] = useHubImageViewerDialog();

	const viewImageHandler = useCallback(
		(image: ImageUrlWithAttribution): void => {
			const imagesWithCurrentImage: ImageUrlWithAttribution[] = isNil(images)
				? []
				: [...images];

			const selectedImage: ImageUrlWithAttribution | undefined = imagesWithCurrentImage
				.find(x => x.url === image.url);

			if (!selectedImage) {
				imagesWithCurrentImage.push(image);
			}

			openImageViewerDialog({
				images: imagesWithCurrentImage,
				initialImageUrl: image.url
			});
		},
		[
			openImageViewerDialog,
			images
		]
	);

	return [
		imageViewerDialog,
		viewImageHandler
	];
}
